// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"425":"392d3586","956":"ebaadaf3"}[chunkId] + ".chunk.js";
};